export const projectName = "Crypto Dragon";
export const contractAddress = "0x7798dE48C2Ed886e7eCD6f00B5C8F889E81bAC2f";
export const opensea = "crypto-dragon-by-vondik";
export const twitter = "CDragonNFT";
export const supply = 1111;
